<template>
  <Base :detail="detail" v-if="prizes && prizes.length > 0" :show-loading="showLoading">
  <div class="luckdraw-warp" :style="'width:' + 636 * baseSize + 'px'">
    <LuckyWheel ref="LuckyWheel" :width="636 * baseSize + 'px'" :height="640 * baseSize + 'px'"
      :default-config="defaultConfig" :blocks="blocks" :prizes="prizes" :buttons="buttons" @start="startCallBack"
      @end="endCallback" />
  </div>
  <div class="active-num" :style="'margin-top:-' +
    112 * baseSize +
    'px;margin-bottom:' +
    56 * baseSize +
    'px;width:' +
    692 * baseSize +
    'px'
    ">
    <img :src="require('@/assets/img/award/luckdraw_bg_1.png')" />
    <div class="active-num-text" :style="'bottom:' + 60 * baseSize + 'px; font-size:' + 24 * baseSize + 'px'
      ">
      <!-- 已有<span>{{ detail.join_num }}</span
        >人参与<br />
        您今天还有<span class="underline yellow">{{ chance }}</span
        >次抽奖机会 -->
      You've got <span class="underline yellow">{{ chance }}</span> times<br>left to draw for today.
    </div>
  </div>
  <PrizeDetail :detail="detail" :myAwards="myAwards" />
  </Base>
</template>

<script>
import { LuckyWheel } from "vue-luck-draw";
import { LuckDrawMixin } from "@/mixins/Luckdraw";
import Cookie from 'js-cookie'
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  mixins: [LuckDrawMixin],
  components: {
    LuckyWheel
  },
  data() {
    return {
      domain: window.location.href.indexOf("sanyglobal.com") > -1 ? "sanyglobal.com" : "sany-test.com",
      blocks: [
        { padding: 0, background: "#fa790f" },
        {
          padding: 60 * baseSize + "px",
          imgs: [
            {
              src: require("@/assets/img/award/luckdraw_bg.png"),
              width: 636 * baseSize + "px",
              rotate: true
            }
          ]
        }
      ],
      prizes: [],
      buttons: [
        { radius: 88 * baseSize + "px", background: "#f6c66f", pointer: false },
        {
          imgs: [
            {
              src: require("@/assets/img/award/start.png"),
              width: 176 * baseSize + "px",
              top: -142 * baseSize + "px"
            }
          ],
          pointer: true
        }
      ],
      defaultConfig: { gutter: "1px", offsetDegree: 180 },
      defaultPrize: [],
      prizeReSort: []
    };
  },
  methods: {
    handleData(data) {
      console.log(this.$route.query)
      const { name = "" } = this.$route.query;
      let temp = { ...data };
      if (!temp.background_img)
        temp.background_img = require("@/assets/img/award/beij.jpg");
      if (!temp.brief_img)
        temp.brief_img = require("@/assets/img/award/title.png");
      this.detail = { ...temp };
      this.myAwards = [...this.detail.my_awards];
      this.chance = this.detail.remaining_num || 0;
      Cookie.set('luckyNum', this.chance, { expires: 31, domain: this.domain })
      this.defaultPrize = temp.prizes.map(item=>({
        ...item,
        image: name==="lighting"?item.image.replace("award0.png","award00.png"):item.image
      }));
      this.prizeReSort = [...this.resort(this.defaultPrize)];
      this.prizes = this.prizeReSort.map(item => ({
        imgs: [
          {
            src: item.image,
            width: 150 * baseSize + "px"
          }
        ],
        background: "#eeffdf"
      }));
    },
    resort(list) {
      if (list.length === 4) {
        const [A, B, C, D] = list;
        return [A, B, C, D, B, C];
      } else if (list.length === 5) {
        const [A, B, C, D, E] = list;
        return [A, B, D, E, C, D];
      } else if (list.length === 6) {
        const [A, B, C, D, E, F] = list;
        return [A, B, D, F, C, E];
      } else if (list.length === 7) {
        const [A, B, C, D, E, F, G] = list;
        return [A, B, C, F, G, D, E, F];
      } else if (list.length === 8) {
        const [A, B, C, D, E, F, G, H] = list;
        return [A, B, C, F, H, D, E, G];
      }
    },
    startCallBack() {
      if (!this.checkLogin()) return;
      const endTime = this.detail.end_time
        ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
        : "";
      const nowTime = new Date().getTime();
      if (!endTime || endTime < nowTime) {
        this.showMessage("Game over!");
        return;
      }
      if (this.chance < 1) {
        this.showMessage("No chance today, come back tomorrow.!");
        return;
      }
      // this.$refs.LuckyWheel.play();
      this.getResult();
    },
    handleResult(data) {
      this.chance -= 1;
      Cookie.set('luckyNum', this.chance, { expires: 31, domain: this.domain })
      this.result = { ...data.award };
      this.$refs.LuckyWheel.play();
      const index = this.getIndex(this.result.id);
      this.$refs.LuckyWheel.stop(index);
    },
    handleError() {
      const index = this.getIndex(0);
      this.$refs.LuckyWheel.stop(index);
    },
    getIndex(id) {
      let temp = [];
      this.prizeReSort.forEach((item, index) => {
        if (item.id === id) temp.push(index);
      });
      const len = temp.length;
      if (len < 1 && id !== 0) return this.getIndex(0);
      else if (len === 1) return temp[0];
      else if (len > 1) return temp[Math.floor(len * Math.random())];
    },
    endCallback(prize) {
      const { id, title, level, image } = this.result;
      if (!this.result || !title) return;
      if (id) this.myAwards.unshift({ id, title, level, image });
      if (id === 0) {
        this.showResult({ type: 1 });
      } else {
        this.showResult({ type: 3, title, level });
      }
    }
  }
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.underline {
  text-decoration: underline;
}

.d-warp {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;

  .main {
    width: 100%;
    min-height: 100vh;

    .luckdraw-warp,
    .title-warp {
      margin: 0 auto;
    }

    .luckdraw-warp {
      position: relative;
      z-index: 2;
    }

    .active-num {
      position: relative;
      z-index: 1;
      margin-left: auto;
      margin-right: auto;

      img {
        padding-left: 1%;
      }
    }

    .active-num-text {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 12px;
      text-align: center;
      color: #fff;
      line-height: 1.4;

      span {
        display: inline-block;
        margin: 0 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LuckyWheel.vue